export default __webpack_public_path__ + "static/9_27-1--4fd2d54fd13de64f0305fed90030f7eb.png";